import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

export const ORDER_BELOW_MIN_PRICE_TITLE = '销售价低于底价';

/** 销售价低于底价 / 优惠：红色五角星（直接引用 SVG，不依赖 initFA 字符串注册） */
const OrderBelowMinPriceIcon = ({ className = '' }) => (
	<FontAwesomeIcon
		icon={faStar}
		className={['text-danger', 'lh-1', 'flex-shrink-0', className].filter(Boolean).join(' ')}
		title={ORDER_BELOW_MIN_PRICE_TITLE}
		aria-label={ORDER_BELOW_MIN_PRICE_TITLE}
	/>
);

OrderBelowMinPriceIcon.propTypes = {
	className: PropTypes.string,
};

export default OrderBelowMinPriceIcon;
